// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cd688814","453":"bbee5cc7","455":"f879b2ca","868":"8d7f5a51","977":"f78549e3"}[chunkId] + ".chunk.js";
};